<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      v-if="Ekstre"
      :data="Ekstre.Ekstre"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      :row-class-name="TableClass">
      <el-table-column
        label="Tarih"
        prop="Tarih"
        width="100">
      </el-table-column>
      <el-table-column
        label="Türü"
        prop="Tur"
        width="100">
      </el-table-column>
      <el-table-column
        label="Makbuz No"
        width="150">
        <template slot-scope="scope">
          <a v-if="scope.row.eNo!='-'" @click="MakbuzGetir(scope.row.eNo)">
            <span>{{ scope.row.eNo }}</span>
          </a>
        </template>
      </el-table-column>
      <el-table-column
        label="Açıklama"
        prop="Aciklama">
      </el-table-column>
      <el-table-column
        label="Emanet"
        prop="Emanet"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Zam"
        prop="Zam"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Borç"
        prop="Borc"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Ödenen"
        prop="Odenen"
        width="100"
        align="right">
      </el-table-column>
      <el-table-column
        label="Kalan"
        prop="Kalan"
        width="100"
        align="right">
      </el-table-column>
    </el-table>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="SayfaYukle"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
import Yukleniyor from "../../../Doc/Yukleniyor";
import MakbuzDetay from "../../Vezne/MakbuzDetay";

export default {
  components: {MakbuzDetay, Yukleniyor},
  props: ["Kisi_id", "Donem"],
  data() {
    return {
      mNo: 0,
      Height: window.innerHeight - 150,
      lo: true,
      search: null,
      MakbuzDetayModal: null,
      Ekstre: {
        Ekstre: [],
        AltToplam: {
          Zam: 0,
          Borc: 0,
          Odenen: 0,
          Kalan: 0,
          Emanet: 0,
        }
      }
    }
  },
  methods: {
    TableClass({row}) {
      return row.TableClass
    },
    TableFooter() {
      const sums = [];
      sums[4] = this.Ekstre.AltToplam.Emanet;
      sums[5] = this.Ekstre.AltToplam.Zam;
      sums[6] = this.Ekstre.AltToplam.Borc;
      sums[7] = this.Ekstre.AltToplam.Odenen;
      sums[8] = this.Ekstre.AltToplam.Kalan;

      return sums;
    },
    MakbuzGetir(mNo) {
      this.mNo = mNo;
      this.MakbuzDetayModal = true
    },
    SayfaYukle() {
      this.lo = true;
      this.MakbuzDetayModal = false;
      this.$store.dispatch("Get", {path: 'yonetim/kisi/ekstre/' + this.Kisi_id + '/' + this.Donem})
        .then(response => {
            //console.log(response);
            if (response.Durum == "OK") {
              this.Ekstre = response;
              this.Height = window.innerHeight - 190;
              this.lo = false
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          }
        )
    },
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    SayfaYenile() {
      return this.Kisi_id
    },
    DonemYenile() {
      return this.Donem
    },
  },
  watch: {
    SayfaYenile() {
      this.SayfaYukle();
    },
    DonemYenile() {
      this.SayfaYukle();
    },
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/KisiEkstre.vue